import React from "react";
import styled from "styled-components";
import { Card } from "antd";

const StyledDiv = styled.div`
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .ant-card {
      width: 90%;
      text-align: center;
      background-color: #e9ecef;
  }

  @media screen and (min-width: 576px) {
    .ant-card {
        width: auto;
    }
`;

const Logo = styled.img`
  height: auto;
  width: 160px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const EventClosed = (props) => {
  const { root } = props;
  const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  };

  const images = importAll(
    require.context("../../../images", false, /\.(png|jpe?g|svg)$/)
  );
  return (
    <StyledDiv backgroundImage={root.backgroundImage} className="main-container">
      <Card>
        <Logo src={images["logo.png"]} />
        <h3>This event has been already closed.</h3>
        <h4>
          If you have any queries, please contact{" "}
          <a href="tel:9728875509">(972) 887-5509</a>
        </h4>
        <h4>Thank You.</h4>
      </Card>
    </StyledDiv>
  );
};

export default EventClosed;
